export const LABELS = {
    tfvWarningMessage: "Total fluid volume exceeds separator capacity.",
    warning: "warning",
    summary: "Summary",
    formula: "Formulas",
    design: "Design:",
    standardSeparation: "Standard separation",
    gasAnchor: "Gas anchor",
    separatorwithcolon: "Separator:",
    separator: "Separator",
    gasHandler: "Gas handler",
    gasHandlerwithcolon: "Gas handler:",
    chargePump1withcolon: "Charge pump 1:",
    chargePump2withcolon: "Charge pump 2:",
    chargePump3withcolon: "Charge pump 3:",
    chargePump1: "Charge pump 1",
    chargePump2: "Charge pump 2",
    chargePump3: "Charge pump 3",
    stg: "stg",
    gasSeparator: "Gas separator",
    gasDesign: "Gas design",
    naturalSeparation: "Natural separation",
    tubingOD: "Tubing OD",
    anchorID: "Anchor ID",
    noOfSeparator: "No. of separators",
    power: "Power@",
    hz: "Hz",
    hp: "hp",
    autoEfficiency: "Auto efficiency",
    in: "in",
    useGasHandler: "Use gas handler",
    yes: "Yes",
    no: "No",
    noOfStages: "No. of stages",
    typeOfShaft: "Type of shaft",
    targetFlowRate: "Target flow rate",
    bpd: "bpd",
    liftStage: "Lift / Stage",
    ft: "ft",
    tdh: "TDH",
    totalbhpGas: "Total BHP @ gas handler",
    bhpGasHandler: "BHP gas handler only",
    efficiency: "Efficiency",
    shaftLoad: "Shaft load",
    showGasHandlerGraph: "Show gas handler graph",
    addChargePump: "Add charge pump",
    useOfChargePump: "Use of charge pump",
    showAllPumps: "Show all pumps",
    chargePump: "Charge pump",
    desirednoOfStages: "Desired no. of stages",
    totalbhpChargePump1: "Total BHP @ charge pump 1",
    bhpChargePump1: "BHP charge pump1 only",
    showChargePump1Graph: "Show charge pump 1 graph",
    totalbhpChargePump2: "Total BHP @ charge pump 2",
    bhpChargePump2: "BHP charge pump2 only",
    showChargePump2Graph: "Show charge pump 2 graph",
    totalbhpChargePump3: "Total BHP @ charge pump 3",
    bhpChargePump3: "BHP charge pump3 Only",
    showChargePump3Graph: "Show charge pump 3 graph",
    preAnchor: "Pre anchor",
    intake: "Intake",
    separator1Discharge: "Separator 1 discharge",
    separator2Discharge: "Separator 2 discharge",
    separator3Discharge: "Separator 3 discharge",
    separator4Discharge: "Separator 4 discharge",
    gasHandlerDischarge: "Gas handler discharge",
    chargePump1Discharge: "Charge pump 1 discharge",
    chargePump2Discharge: "Charge pump 2 discharge",
    chargePump3Discharge: "Charge pump 3 discharge",
    naturalSepa: "Natural separation (%)",
    separatorEfficiency: "Separator efficiency (%)",
    flowFactor: "Flow factor (%)",
    headFactor: "Head factor (%)",
    powerFactor: "Power factor (%)",
    rs: "Rs (scf/bbl)",
    bg: "Bg (bbl/mcf)",
    bo: "Bo (bbl/stb)",
    volumeOfGas: "Volume of gas (bpd)",
    volumeOfOil: "Volume of oil (bpd)",
    volumeOfWater: "Volume of water (bpd)",
    totalFluidVolume: "Total fluid volume (bpd)",
    freeGas: "Free Gas / GVF (%)",
    gor: "GOR (scf/stb)",
    glr: "GLR (scf/stb)",
    liquidPhaseDensity: "Liquid phase density (lb/ft^3)",
    gasCompressibility: "Gas compressibility",
    pressure: "Pressure (psi)",
    compositeSpgr: "Composite SpGr",
    finalFlop: "Final flop (ft)",
    liquidPhaseSpgr: "Liquid phase SpGr",
    finalTemp: "Final temperature (°F)",
};